import { render, staticRenderFns } from "./ListSectionItem.vue?vue&type=template&id=207b8e36&scoped=true&"
import script from "./ListSectionItem.vue?vue&type=script&lang=js&"
export * from "./ListSectionItem.vue?vue&type=script&lang=js&"
import style0 from "./ListSectionItem.vue?vue&type=style&index=0&id=207b8e36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207b8e36",
  null
  
)

export default component.exports